export default function Footer() {
  return (
    <div>
      <div class="bg-gray-100">
        <div class="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
          <p class="text-gray-500 text-sm text-center sm:text-left">
          Disclaimer: Tranquil is not in the business of
    providing counselling services and does not own, operate or control the content listed on the website and does not take responsibility for its impact on users. The
    content of this website is for referral purposes only, and is not a substitute for therapy.
    Tranquil disclaims all liability for damages of any kind arising due to content of this website.
            
          </p>
          <span class="sm:ml-auto sm:mt-0 mt-2 sm:w-auto w-full sm:text-center text-center text-gray-500 text-sm">
            Created by Niharika and Kapil.
          </span>
        </div>
      </div>
    </div>
  );
}
